import { type Document, type Stored, UNTITLED_DOCUMENT_TITLE } from "@overmap-ai/common"
import { selectDocuments } from "@overmap-ai/core"
import { ReactRenderer } from "@tiptap/react"

import { appStore } from "../../../../store"
import type { MentionListRootProps } from "../../../blocks/MentionList/Root"
import type { MentionListRef } from "../../../blocks/MentionList/typings"
import { DocumentMentionList } from "../../../components/MentionLists"
import type { SuggestionOptions } from "../typings"
import { updatePosition } from "../utils"

export const suggestion: SuggestionOptions<Stored<Document>> = {
	char: "@d",
	items: ({ query }) => {
		const documents = selectDocuments(appStore.getState())

		return documents
			.filter((document) =>
				(document.title || UNTITLED_DOCUMENT_TITLE).toLowerCase().startsWith(query.toLowerCase()),
			)
			.slice(0, 10)
	},

	render: () => {
		let component: ReactRenderer<MentionListRef<Stored<Document>>, MentionListRootProps<Stored<Document>>>

		return {
			onStart: (props) => {
				component = new ReactRenderer(DocumentMentionList, {
					props,
					editor: props.editor,
					as: "div",
				})

				if (!props.clientRect) {
					return
				}

				;(component.element as HTMLElement).style.position = "fixed"
				component.element.setAttribute("data-floating-content", "")

				document.body.appendChild(component.element)

				updatePosition(props.editor, component.element as HTMLElement)
			},

			onUpdate(props) {
				component.updateProps(props)

				if (!props.clientRect) {
					return
				}

				updatePosition(props.editor, component.element as HTMLElement)
			},

			onKeyDown(props) {
				if (props.event.key === "Escape") {
					component.destroy()

					return true
				}

				return component.ref?.onKeyDown?.(props) ?? false
			},

			onExit() {
				component.element.remove()
				component.destroy()
			},
		}
	},
}
